import { IAlarmCentralProps } from '../../../../../services/AlarmCentralService/types';
import { Box, Typography } from '@mui/material';
import CardComponent from '../../../../../components/CardComponent/CardComponent';
import {
  useSendPgmActivation,
  useSendPgmDeactivation,
} from '../../../../../services/AlarmCentralService/Physical/hooks/useMutation';
import { AlarmCentralEndpoint } from '../../../../../services/AlarmCentralService/enums';
import { useEffect, useState } from 'react';
import { IAlarmCentralVettiStatusProps } from '../../../../../services/AlarmCentralService/Physical/Vetti/types';

interface AlarmCentralPhysicalJflPgmsProps {
  alarmCentral: IAlarmCentralProps;
  status: IAlarmCentralVettiStatusProps;
}

const AlarmCentralPhysicalJflPgms = ({
  status,
  alarmCentral,
}: AlarmCentralPhysicalJflPgmsProps) => {
  const [isLoadingPgm, setIsLoadingPgm] = useState<boolean[]>([]);
  const { mutateAsync: mutateSendPgmActivation } = useSendPgmActivation();
  const { mutateAsync: mutateSendPgmDeactivation } = useSendPgmDeactivation();

  const activateOrDeactivatePgm = async (active: boolean, pgm: number) => {
    const isl = [...isLoadingPgm];
    isl[pgm - 1] = true;
    setIsLoadingPgm(isl);

    if (active) {
      await mutateSendPgmActivation({
        pgm,
        endpoint: AlarmCentralEndpoint.ALARM_CENTRAL_VETTI_ENDPOINT,
        id: alarmCentral.id,
      });
      return;
    }
    await mutateSendPgmDeactivation({
      pgm,
      endpoint: AlarmCentralEndpoint.ALARM_CENTRAL_VETTI_ENDPOINT,
      id: alarmCentral.id,
    });
  };

  useEffect(() => {
    const isLoading: boolean[] = [];
    for (let i = 0; i < alarmCentral.pgmQuantity; i++) isLoading.push(false);

    setIsLoadingPgm(isLoading);
  }, [status, alarmCentral]);

  return (
    <Box sx={{ overflowX: 'auto', display: 'flex', gap: 1.5, py: 1 }}>
      {[...Array(alarmCentral.pgmQuantity)].map((_, index) => (
        <Box key={index}>
          <CardComponent
            isLoading={isLoadingPgm[index]}
            onClick={() =>
              activateOrDeactivatePgm(!status.isPgmsActivated[index], index + 1)
            }
            additionalMessage={
              status.isPgmsActivated[index] ? 'Acionada' : 'Desacionada'
            }
            representativeColor={
              status.isPgmsActivated[index] ? 'green' : 'red'
            }
            tooltipMessage={'Clique para acionar'}
          >
            <Typography sx={{ fontWeight: 'bold' }}>PGM {index + 1}</Typography>
          </CardComponent>
        </Box>
      ))}
    </Box>
  );
};

export default AlarmCentralPhysicalJflPgms;
